import { DynamicQuerySearchInput } from '@pages/advanced-search/types'

import { ApiRequest } from '../baseService'

const BaseRoute = 'app/dynamic-query'

function GetTargets() {
  return ApiRequest.get(`${BaseRoute}/targets`)
}

function Search(targetKey: string, input: DynamicQuerySearchInput) {
  return ApiRequest.post(`${BaseRoute}/${targetKey}/search`, input)
}

function Count(targetKey: string, input: DynamicQuerySearchInput) {
  return ApiRequest.post(`${BaseRoute}/${targetKey}/count`, input)
}

export default { GetTargets, Search, Count }
